export const spacing = {
  base: 10, // 10px
};

export const calcSpacing = (multiplier: number, base: number = spacing.base) =>
  base * multiplier;
